import ReactSelect from 'react-select';

import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");
var ZPDRange = require("lib/academic/ZPDRange");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var BookCover = require("components/reading/books/BookCover");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ValidatingInput = require("components/utility/ValidatingInput");
var TextTypes = require("lib/academic/TextTypes");
var Spinner = require("components/utility/Spinner");
var ReactTooltip = require("react-tooltip");

var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");

var PaywallModal = require("components/users/teachers/PaywallModal");

require("reading/books/smart_book_search.scss");

@connect(
	(state, props) => {
		if (props.existingAssignedBooks) {
			return { existingBooks: props.existingAssignedBooks };
		}
		else if (props.userID) {
			// See BookActionSection selector conditions before changing
			var books = ReadingSelectors.books({ state, 
				conditions: { userID: props.userID, allowDraft: true, nonBlank: ["text_id", "title"] }});
			books = _.sortBy(books, "last_active").reverse();
			return { existingBooks: books };
		} else {
			return {};
		}
	},
	(dispatch, props) => ({
		populateData: () => {
			if (props.userID) {
				dispatch(ReadingActions.fetchBookActivity({
					conditions: { userID: props.userID, allowDraft: true },
					cache: true, fetchDetails: true
				}));
			}
		}
	})
)
class SmartBookSearch extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			searchOptions: null, currentInput: "",
			searchTimer: null, showManualFields: false, isManualURL: false, loadingSearch: false, 
			matildaError: false, grSearchComplete: false, searchPending: false, showAddManual: false,
			trustedSearchComplete: false, regularSearchComplete: false
		}
	}

	selectBook(selection) {
		if (selection && selection.value) {
			if (selection.value.flagToggleManual) {
				if (CurrentUser.get().prefs.automatic_zpd_exclusion && CurrentUser.isStudent()) {
					if (confirm("This book will not count toward your goals unless your teacher chooses to make it count. Do you want to continue?")) {
						this.toggleManual()
					}
				} else {
					this.toggleManual()
				}
			} else if (selection.value.flagEmptySpace == undefined) {
				if (CurrentUser.get().prefs.automatic_zpd_exclusion && CurrentUser.isStudent()) {
					var studentReadingLevel = CurrentUser.get().current_reading_level;

					var textReadingLevel = selection.value.lexile_score;

					if (textReadingLevel == undefined) {
						if (confirm("This book will not count toward your goals unless your teacher chooses to make it count. Do you want to continue?")) {
							var isFirst = (_.size(this.props.existingBooks) == 0);
							this.props.onBookSelect(selection.value, isFirst);
						}
					} else {
						var zpdStatus = ZPDRange.getTextStatus(
							textReadingLevel, studentReadingLevel
						);

						var confirmMessage = "This book is below your reading level and will not count toward your goals. Do you want to continue?";

						if ((zpdStatus != ZPDRange.UNDER) || confirm(confirmMessage)) {
							var isFirst = (_.size(this.props.existingBooks) == 0);
							this.props.onBookSelect(selection.value, isFirst);
						}
					}
				} else {
					var isFirst = (_.size(this.props.existingBooks) == 0);
					this.props.onBookSelect(selection.value, isFirst);
				}
				
				if (this.state.searchOptions) {
					var indexSelect = this.state.searchOptions.map((so) => {
						return so.value.text_id;
					}).indexOf(selection.value.text_id);

					Mycroft.newEvent({ 
						category: "Book Select", 
						action: "index-selected-" + indexSelect, 
						label: selection.value.title });
				}
				this.setState({ 
					showManualFields: false,
					searchOptions: [], 
					currentInput: selection.value.title });
			}
		} else {
			this.props.onBookSelect(null);
		}
	}
	toggleManual(e) {
		$wr.nope(e)
		this.setState({ showManual: !this.state.showManual }, () => {
			if (this.state.showManual) {
				this.refs.manualTitle.focus()
			}
		});
	}
	setManualURL(value) {
		this.setState({ isManualURL: value });
	}
	resetSearch() {
		this.setState({ trustedSearchComplete: false, regularSearchComplete: false, grSearchComplete: false, 
							loadingSearch: false })
	}
	searchBooks(input) {
		if (!this.props.blockSearch) {
			this.resetSearch()
			var trimInput = input.trim();

			if (trimInput.length == 0) {
				this.setState({ searchOptions: [], currentInput: input });

			} else {
				var searchKey = Math.random();
				this._searchKey = searchKey;

				setTimeout(function() {
					if (searchKey == this._searchKey) {
						var searchParams = { q: trimInput, trusted: true };
						this.triggerMatilda(searchParams)					
					}

				}.bind(this), DELAY_SEARCH_TIME);
				this.setState({ currentInput: input, loadingSearch: true });
			}
		} else {
			this.refs.paywallModal.show();
		}
	}

	scrollTriggerMatilda() {
		// TRIGGER REGULAR SEARCH
		var searchParams = { q: this.state.currentInput.trim()}
		// UNLESS REGULAR SEARCH WAS COMPLETED, THEN TRIGGER GR SEARCH
		if (this.state.regularSearchComplete) {
			searchParams.gr = true;
		}

		if (!this.state.grSearchComplete && this.state.currentInput != "") {
			this.setState({ loadingSearch: true })
			this.triggerMatilda(searchParams)
		}
	}

	handleTrustedSearchCallback(searchParams, searchOptions) {
		this.setState({ 
			searchOptions: searchOptions,
			loadingSearch: false,
			searchPending: false,
			trustedSearchComplete: true
		}, () => {
			if (searchOptions.length < 3 && !this.state.grSearchComplete) {
				delete searchParams["trusted"] // REMOVE TRUSTED TO MAKE REGULAR SEARCH
				this.triggerMatilda(searchParams);
			}
		});
	}

	handleGrSearchCallback(searchParams, searchOptions) {
		this.setState({
			searchOptions: this.addGrResults(searchOptions),
			loadingSearch: false,
			grSearchComplete: true,
			searchPending: false,
			showAddManual: true
		});
	}

	handleRegularSearchCallback(searchParams, searchOptions) {
		var data = this.addGrResults(searchOptions)
		this.setState({ 
			searchOptions: data,
			regularSearchComplete: true,
			loadingSearch: false,
			searchPending: false
		}, () => {
			if (data.length < 3 && !this.state.grSearchComplete) {
				searchParams["gr"] = true;
				this.triggerMatilda(searchParams);
			}
		});
	}

	formatSearchOptions(data) {
		return _.map(data.results, function(book) {
			return { value: book, label: this.state.currentInput }
		}.bind(this));
	}

	triggerMatilda(searchParams) {
		if (!this.state.searchPending) {
			this.setState({searchPending: true, showAddManual: false})
			var url = WhooosReadingServices.Matilda.url("/search", searchParams);

			// IN CASE SEARCH TAKES TOO LONG, DISPLAY MANUAL INPUT
			const timeout = setTimeout(function() {
		        this.setState({showAddManual: true})
		    }.bind(this), FETCH_TIMEOUT);

	    	$wr.requestJSON(url, null, "GET", function(data) {
	    		clearTimeout(timeout);
	    		var searchOptions = this.formatSearchOptions(data)

	    		// HANDLE THREE CALLBACKS FOR 3 TYPES OF SEARCH
				if ("trusted" in searchParams) {
					this.handleTrustedSearchCallback(searchParams, searchOptions)
				} else if ("gr" in searchParams) {
					this.handleGrSearchCallback(searchParams, searchOptions)
				} else {
					this.handleRegularSearchCallback(searchParams, searchOptions)
				}

	    	}.bind(this), function(data) {
	    		this.setState({ matildaError: true })
	    	}.bind(this));
	    }
	}

	addGrResults(grResults) {
		var mergedResults = (this.state.searchOptions || []).concat(grResults);
		var text_id_arr = mergedResults.map(function(text){return text.value.text_id})
		return mergedResults.filter(function(item, pos) {
			return text_id_arr.indexOf(item.value.text_id) == pos;
		});
	}

	draftClick(textID, activityType, e) {
		if (e) {
			$wr.nope(e)
			e.stopPropagation();
		}

		if (activityType == "quiz") {
			$wr.redirect("/quiz?text_id=" + textID);

		} else if (activityType == "answer") {
			$wr.redirect("/answers/new?text_id=" + textID);

		} else if (activityType == "review") {
			$wr.redirect("/reviews/new?text_id=" + textID);

		} else if (activityType == "exercise") {
			$wr.redirect("/responses/new?text_id=" + textID);
		}
	}

	shouldDisplayZPD(){
		// if not a student, don't display them. Relevant for the question search page.
		if (!CurrentUser.isStudent()) { return false }
		// if they are a student, base it out of prefs 
		return CurrentUser.get().prefs.show_students_zpd_icon
	}

	optionRenderer(optionData, index) {
		var book = optionData.value;
		if (book.flagToggleManual) {
			var manualText = "We don't have that book.";
			var linkText = "Add it now!"

			return (
				<span className="searchOpDisplay">
					<Glyphicon icon="book" className="coverIconSub" />
					<span>
						{ manualText }{" "}
						<a href="#" onClick={ $wr.nope }>{ linkText }</a>
					</span>
				</span>
			);
		} else if (book.flagEmptySpace) {
			return (
				<span className="emptyContainer"><Spinner scale={ 1.2 } /></span>
			)
		} else if (book.flagPlaceholder) {
			return (
				<span className="placeholderContainer"></span>
			)
		} else {
			var draftIcons = [];
			if (_.any(book.quiz_draft_counts)) {
				draftIcons.push(
					<span className="draftPair" key="quiz" 
						onMouseDown={ this.draftClick.bind(this, book.text_id, "quiz") } >
						<img src={ require("quiz-icons/open-no-ss-complete.png") }
							key="quiz" className="quizDraftIcon" title="Draft quiz" />
						<br/>Quiz
					</span>
				)
			}
			if (_.any(book.answer_draft_counts)) {
				draftIcons.push(
					<span className="draftPair" key="answer" 
						onMouseDown={ this.draftClick.bind(this, book.text_id, "answer") } >
						<img src={ require("reading/question-small.png") }
							key="answer" title="Draft answer" />
						<br/>Answer
					</span>
				)
			}
			if (_.any(book.review_draft_counts)) {
				draftIcons.push(
					<span className="draftPair" key="review" 
						onMouseDown={ this.draftClick.bind(this, book.text_id, "review") } >
						<img src={ require("reading/review-small.png") }
							key="review" title="Draft review" />
						<br/>Review
					</span>
				)
			}
			if (_.any(book.response_draft_counts)) {
				draftIcons.push(
					<span className="draftPair" key="exercise" 
						onMouseDown={ this.draftClick.bind(this, book.text_id, "exercise") } >
						<img src={ require("reading/exercise-small.png") }
							key="exercise" title="Draft exercise" />
						<br/>Exercise
					</span>
				)
			}

			return (
				<span className="searchOpDisplay">
					<BookCover book={ book } coverWidth={ 40 } showTitle showAuthor 
						showReadingLevelIcon={this.shouldDisplayZPD()} />
					<span className="draftIcons">
						{ draftIcons }
					</span>
				</span>
			);
		}
	}

	getNonTechnicalOptions() {
		var allOptions = []
		if (this.props.existingBooks) {
			allOptions = allOptions.concat(_.map(this.props.existingBooks, (book) => {
				return { value: book, label: book.title }
			}));
		}
		if (this.state.searchOptions) {
			allOptions = allOptions.concat(this.state.searchOptions);
		}

		allOptions = _.uniq(allOptions, (option) => { return option.value.text_id });
		return allOptions;
	}

	getOptions() {
		var allOptions = this.getNonTechnicalOptions();

		if ((this.state.currentInput && this.state.currentInput.trim().length > 0) && !this.state.grSearchComplete) {
			allOptions.push({ label: this.state.currentInput, value: { flagEmptySpace: true } })
		}

		if ((this.state.currentInput && this.state.currentInput.trim().length > 0) && this.state.showAddManual && !this.props.preventManual) {
			allOptions.push({ label: this.state.currentInput, value: { flagToggleManual: true } });		
		}

		// if (allOptions.length == 0) {
		// 	allOptions.push({ label: "...", value: { flagPlaceholder: true } });		
		// }


		return allOptions;
	}

	onManualSubmit(e) {
		$wr.nope(e)
		if (this.validateForm()) {
			var book = {
				title: this.refs.manualTitle.val(),
				text_variety: $(this.refs.manualTextVariety).val()
			}

			if (this.state.isManualURL) {
				book["url"] = this.refs.manualURL.val();
			} else {
				book["author_full_name"] = this.refs.manualAuthor.val();
			}

			this.selectBook({ label: book.title, value: book });
			this.setState({ showManual: false, currentInput: "" })
		}	
	}

	validateForm() {
		if (this.state.isManualURL) {
			return this.refs.manualTitle.validate() &
				this.refs.manualURL.validate();

		} else {
			return this.refs.manualTitle.validate() &
				this.refs.manualAuthor.validate();			
		}
	}

	renderManualForm() {
		if (this.state.isManualURL) {
			var secondField = (
				<ValidatingInput type="text" ref="manualURL" key="url"
					validators={ ValidatingInput.Validators.URL }
					inputClassName="form-control" className="url"
					placeholder="Website URL" 
					errorMessage="Copy/paste a website URL" />
			);

		} else {
			var secondField = (
				<ValidatingInput type="text" ref="manualAuthor" key="author"
					validators={ ValidatingInput.Validators.PRESENT }
					inputClassName="form-control" className="author"
					placeholder="Author" 
					errorMessage="Please enter an author." />
			);
		}

		// <div className="bookTypeControl">
		// 	<label className="clickableElement">
		// 		<input type="radio" checked={ !this.state.isManualURL }
		// 			onChange={ this.setManualURL.bind(this, false) } /> Add a book
		// 	</label>
		// 	<span className="or">Or</span>
		// 	<label className="clickableElement">
		// 		<input type="radio" checked={ this.state.isManualURL }
		// 			onChange={ this.setManualURL.bind(this, true) } /> Add online reading
		// 	</label>
		// </div>


		return (
			<form onSubmit={ this.onManualSubmit } className="manualForm">
				<div>
					<a href="#" onClick={ this.toggleManual } className="backArrow">
						<Glyphicon icon="arrow-left" />
					</a>
					<ValidatingInput type="text" ref="manualTitle"
						defaultValue={ this.state.currentInput }
						validators={ ValidatingInput.Validators.PRESENT }
						inputClassName="form-control" className="title"
						placeholder="Title"
						errorMessage="Please enter a title." />

					{ secondField }

					<select className="form-control textVariety" ref="manualTextVariety">
						<option value={ TextTypes.Varieties.FICTION }>
							{ TextTypes.Varieties.getName(TextTypes.Varieties.FICTION) }
						</option>
						<option value={ TextTypes.Varieties.NON_FICTION }>
							{ TextTypes.Varieties.getName(TextTypes.Varieties.NON_FICTION) }
						</option>
					</select>

					<button className="buttonSuccess">
						Add Book
					</button>
				</div>
			</form>
		)
	}

	renderSearch() {
		var book = this.props.selectedBook;
		if (book) {
			var selectedOption = { value: book, label: book.title };			
		}

		if (this.state.matildaError) {
			var noResultsText = "Our book finder is having trouble loading books at this time. Try again in a few minutes."
			var reactSelectClass = "reactSelectError"
		} else {
			var noResultsText = "";	
		}

		var searchOptions = this.state.searchOptions;

		return (
			<div className="searchBar" ref="searchBar">
				<ReactSelect className={ "reactSelectContainer " + reactSelectClass } 
					onInputChange={ this.searchBooks } ref="searchInput"
					onBlurResetsInput={ false }
					noResultsText={ noResultsText }
					value={ selectedOption } placeholder="Book title..."
					optionRenderer={ this.optionRenderer } onChange={ this.selectBook }
					onFocus={ this.onFocus } onBlur={ this.onBlur }
					options={ this.getOptions() } isLoading={this.state.loadingSearch} />
			</div>
		);
	}

	render() {
		var className = "smartBookSearch";
		if (this.props.dropUp) {
			className += " dropUp";
		}

		if (this.state.showManual) {
			var display = this.renderManualForm();
		} else {
			var display = this.renderSearch();
		}


		if (this.props.blockSearch) {
			var logsPaywall = (
				<PaywallModal ref="paywallModal" featureType={ PaywallModal.TEACHER_PICKS } />
			);
		}	


		return (
			<div className={ className }>
				{ display }
				{ logsPaywall }
			</div>
		);
	}

	selectMenuNode() {
		return $(this.refs.searchBar).find(".Select-menu");
	}

	onFocus() {
		setTimeout(() => {
			this.selectMenuNode().on("scroll", this.onSelectScroll)
		}, 30)
	}
	onBlur() {
		this.selectMenuNode().off("scroll", this.onSelectScroll)
	}

	onSelectScroll() {
		var $menu = this.selectMenuNode();
		if ($menu.length > 0) {
			var innerHeight = $menu[0].scrollHeight;
			var outerHeight = $menu.height();
			var scrollTop = $menu.scrollTop();
			var cushion = 100;

			var calc = innerHeight - (scrollTop + outerHeight + cushion);

			if (calc <= 0) {
				this.scrollTriggerMatilda();
			}
		}
	}

	componentDidMount() {
		if (this.props.populateData) {
			this.props.populateData();
		}
	}

	componentWillUnmount() {
		this.onBlur()
	}
}

const FETCH_TIMEOUT = 30;
const DELAY_SEARCH_TIME = 1500;

SmartBookSearch.propTypes = PageStrictPropTypes({
	// User ID to show past books for this userID
	userID: PropTypes.number,
	// Books already ready (selected by userID)
	existingBooks: PropTypes.array,

	existingAssignedBooks: PropTypes.array,
	// Method to fetch populate inital data (i.e. existingBooks)
	populateData: PropTypes.func,

	selectedBook: PropTypes.object,

	// Makes the drop down point up, rather than down
	dropUp: PropTypes.bool,

	smartBookSearch: PropTypes.bool,

	onBookSelect: PropTypes.func.isRequired,

	preventManual: PropTypes.bool
});


module.exports = SmartBookSearch;


// WEBPACK FOOTER //
// ./modules/components/reading/books/SmartBookSearch.js